import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { stockApi, type StockEditProposedChanges, type StockEditTargetType } from "@/lib/stock.api";
import { queryKeys } from "@/lib/query-keys";

export function useRequestStockEditMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      articleId,
      targetType,
      reason,
      proposedChanges,
    }: {
      articleId: number;
      targetType: StockEditTargetType;
      reason: string;
      proposedChanges: StockEditProposedChanges;
    }) => stockApi.requestEdit(articleId, targetType, reason, proposedChanges).then((r) => r.data),
    onSuccess: () => {
      toast.success("Demande soumise - en attente de validation.");
      queryClient.invalidateQueries({ queryKey: queryKeys.stockEditRequests() });
    },
  });
}
